import { render } from "./qxc-kua.vue?vue&type=template&id=b1b8f3d6&scoped=true"
import script from "./qxc-kua.vue?vue&type=script&lang=js"
export * from "./qxc-kua.vue?vue&type=script&lang=js"

import "./qxc-kua.vue?vue&type=style&index=0&id=b1b8f3d6&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1b8f3d6"]])

export default __exports__